import React from 'react';
import { Badge } from '@mantine/core';
import type { EntityRegistryEntry, ColumnOptions } from '../types';
import { getRequestApprovalTypeWarnings } from '../../validation/requestApprovalTypeValidation';

export const requestApprovalTypeConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'Type', 'Description', 'DurationDays', 'ActorThreshold', 'IsSystem'],
    listColumns: ({ isStandard }: ColumnOptions) => {
        const columns = [
            {
                key: 'type',
                label: 'Type',
                sortable: true,
                render: (entity: any) => {
                    const t = (entity.Type || '').toString().trim();
                    if (!t) return '';
                    const color = t.toLowerCase() === 'possessive' ? 'violet' : 'cyan';
                    return <Badge variant="light" color={color} size="sm">{t}</Badge>;
                }
            },
            {
                key: 'description',
                label: 'Description',
                sortable: true,
                render: (entity: any) => {
                    const desc = entity.Description || '';
                    if (!desc) return '';
                    return desc.length > 80 ? `${desc.slice(0, 80)}...` : desc;
                }
            },
            {
                key: 'durationdays',
                label: 'Duration',
                sortable: true,
                render: (entity: any) => {
                    const val = entity.DurationDays;
                    if (val == null || val === '') return '';
                    return `${val} day${val === 1 ? '' : 's'}`;
                }
            },
            {
                key: 'actorthreshold',
                label: 'Threshold',
                sortable: true,
                render: (entity: any) => {
                    const val = entity.ActorThreshold;
                    if (val == null || val === '') return '';
                    return `${val} required`;
                }
            }
        ];

        if (!isStandard) {
            columns.push({
                key: 'issystem',
                label: 'System',
                sortable: true,
                render: (entity: any) => {
                    const raw = entity.IsSystem;
                    const sys = typeof raw === 'boolean' ? raw : (typeof raw === 'string' ? raw.toLowerCase() === 'true' : !!raw);
                    if (!sys) return '';
                    return <Badge variant="outline" size="sm" color="blue">System</Badge>;
                }
            });
        }

        return columns;
    },
    getWarnings: (data, options) => getRequestApprovalTypeWarnings(data, {
        isCloneMode: options?.isCloneMode,
        existingEntityDisplayName: options?.existingEntityDisplayName,
    }),
};
